import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, Button, FormGroup, Input } from "reactstrap"

import { connect } from "react-redux";
import Select from "react-select"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

import { useDispatch } from "react-redux";
import Loader from "components/Loader/Loader";
import { deleteCourse, fetchAllCourses } from "helpers/course_helper";
import { toast } from "react-toastify";
import { DOWNLOAD_COURSE_DETAILS_FILE, FETCH_IMAGE } from "helpers/url_helper";
import { useNavigate } from "react-router-dom";
import { generatePresignedUrlForAccess } from "helpers/Content_helper";
import axios from "axios";
import { TextField } from "@mui/material";
import { fetchAllCategory } from "helpers/category_helper";
import { fetchAllSubCategoryBasedOnCategory } from "helpers/subCategory_helper";
import { fetchAllLevel } from "helpers/level_helper";

const AllCourses = (props) => {
    document.title = "Question Bank | All Courses";
    const [modalShow, setModalShow] = useState(false);
    const [courseName, setCourseName] = useState("");
    const [courseDescription, setCourseDescription] = useState("");
    const [courseCode, setCourseCode] = useState("");
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [id, setId] = useState({});
    const [classs, setClasss] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [allCourses, setAllCourses] = useState([]);
    const [filteredCourses, setFilteredCourses] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    // New state for filters
    const [allCategories, setAllCategories] = useState([]);
    const [allSubCategories, setAllSubCategories] = useState([]);
    const [allLevels, setAllLevels] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);
    const [selectedLevel, setSelectedLevel] = useState(null);
    const [filteredSubCategories, setFilteredSubCategories] = useState([]);

    const breadcrumbItems = [
        { title: "Course", link: "#" },
        { title: "All Courses", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems('All Courses', breadcrumbItems)
    }, [])

    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])

    useEffect(() => {
        fetchCourses();
        fetchCategories();
        fetchLevels();
    }, []);

    useEffect(() => {
        // Filter and sort courses
        let filtered = [...allCourses];

        // Filter by search term (title)
        if (searchTerm && searchTerm.trim() !== "") {
            filtered = filtered.filter(course =>
                course?.title?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Filter by category - using categoryDto.id or categoryId
        if (selectedCategory) {
            filtered = filtered.filter(course => {
                // Check if course has categoryDto with id matching selected category
                if (course?.categoryDto?.id) {
                    return course.categoryDto.id === selectedCategory.id;
                }
                // Check if course has categoryId directly
                if (course?.categoryId) {
                    return course.categoryId === selectedCategory.id;
                }
                return false;
            });
        }

        // Filter by subcategory - using subCategoryDto.id or subCategoryId
        if (selectedSubCategory) {
            filtered = filtered.filter(course => {
                // Check if course has subCategoryDto with id matching selected subcategory
                if (course?.subCategoryDto?.id) {
                    return course.subCategoryDto.id === selectedSubCategory.id;
                }
                // Check if course has subCategoryId directly
                if (course?.subCategoryId) {
                    return course.subCategoryId === selectedSubCategory.id;
                }
                return false;
            });
        }

        // Filter by level - using levelDto.id or levelId
        if (selectedLevel) {
            filtered = filtered.filter(course => {
                // Check if course has levelDto with id matching selected level
                if (course?.levelDto?.id) {
                    return course.levelDto.id === selectedLevel.id;
                }
                // Check if course has levelId directly
                if (course?.levelId) {
                    return course.levelId === selectedLevel.id;
                }
                return false;
            });
        }

        // Sort courses by level (ascending order)
        filtered.sort((a, b) => {
            // Get level numbers
            let levelA = 999;
            let levelB = 999;
            
            // Try to get level from levelDto
            if (a?.levelDto?.id) {
                levelA = parseInt(a.levelDto.id);
            } else if (a?.levelId) {
                levelA = parseInt(a.levelId);
            } else if (a?.levelDto?.level) {
                levelA = parseInt(a.levelDto.level);
            } else if (a?.level) {
                levelA = parseInt(a.level);
            }
            
            if (b?.levelDto?.id) {
                levelB = parseInt(b.levelDto.id);
            } else if (b?.levelId) {
                levelB = parseInt(b.levelId);
            } else if (b?.levelDto?.level) {
                levelB = parseInt(b.levelDto.level);
            } else if (b?.level) {
                levelB = parseInt(b.level);
            }
            
            // Sort ascending (level 1 first, then level 2, etc.)
            if (levelA < levelB) return -1;
            if (levelA > levelB) return 1;
            return 0;
        });

        setFilteredCourses(filtered);
    }, [searchTerm, selectedCategory, selectedSubCategory, selectedLevel, allCourses]);

    const fetchCourses = async () => {
        try {
            setLoader(true);
            const data = await fetchAllCourses();
            setLoader(false);
            if (data?.success) {
                console.log("Course data:", data?.result);
                updateThubmnail(data?.result);
            }
            else {
                toast.error(data?.message || "Failed to fetch courses");
            }
        } catch (error) {
            setLoader(false);
            console.error("Error fetching courses:", error);
            toast.error(error?.response?.data?.message || "Failed to fetch courses");
        }
    }

    const fetchCategories = async () => {
        try {
            const data = await fetchAllCategory();
            if (data?.success) {
                setAllCategories(data?.result || []);
                console.log("Categories:", data?.result);
            }
            else {
                console.error("Failed to fetch categories:", data?.message);
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    }

    const fetchSubCategories = async (categoryId) => {
        try {
            setLoader(true);
            // Try to fetch subcategories with proper headers
            const authUser = localStorage.getItem('authUser');
            const organizationId = authUser ? JSON.parse(authUser)?.organizationId : null;
            
            // Make direct axios call with proper headers
            const response = await axios.get(
                `https://backend.skillserve.in/getAllSubCategoryBasedOnCategory?categoryId=${categoryId}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        ...(organizationId && { 'X-Organization-ID': organizationId })
                    }
                }
            );
            
            setLoader(false);
            
            if (response?.data?.success) {
                setAllSubCategories(response?.data?.result || []);
                setFilteredSubCategories(response?.data?.result || []);
                console.log("SubCategories for category:", response?.data?.result);
            } else {
                setAllSubCategories([]);
                setFilteredSubCategories([]);
                if (response?.data?.message) {
                    toast.warning(response.data.message);
                }
            }
        } catch (error) {
            setLoader(false);
            console.error("Error fetching subcategories:", error);
            // Don't show error toast for subcategory fetch failure
            setAllSubCategories([]);
            setFilteredSubCategories([]);
        }
    }

    const fetchLevels = async () => {
        try {
            const data = await fetchAllLevel();
            if (data?.success) {
                setAllLevels(data?.result || []);
                console.log("Levels:", data?.result);
            }
            else {
                console.error("Failed to fetch levels:", data?.message);
            }
        } catch (error) {
            console.error("Error fetching levels:", error);
        }
    }

    const handleCategoryChange = (selectedValue) => {
        setSelectedCategory(selectedValue);
        setSelectedSubCategory(null); // Reset subcategory when category changes
        if (selectedValue) {
            fetchSubCategories(selectedValue.id);
        } else {
            setAllSubCategories([]);
            setFilteredSubCategories([]);
        }
    }

    const handleSubCategoryChange = (selectedValue) => {
        setSelectedSubCategory(selectedValue);
    }

    const handleLevelChange = (selectedValue) => {
        setSelectedLevel(selectedValue);
    }

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleDelete = async (id) => {
        console.log(id);
        try {
            setLoader(true);
            const data = await deleteCourse(id);
            setLoader(false);
            if (data?.success) {
                toast.success(data?.message || "Course deleted successfully");
                fetchCourses();
            }
            else {
                toast.error(data?.message || "Failed to delete course");
            }
        } catch (error) {
            setLoader(false);
            console.error("Error deleting course:", error);
            toast.error(error?.response?.data?.message || "Failed to delete course");
        }
    }

    const handleEdit = async (id) => {
        console.log(id);
        navigate("/edit-course/" + id);
    }

    const updateThubmnail = async (data) => {
        if (!data || data.length === 0) {
            setAllCourses([]);
            setFilteredCourses([]);
            return;
        }

        try {
            const updateData = await Promise.all(
                data.map(async (d) => {
                    if (d?.thumbnailName) {
                        let name = d.thumbnailName;
                        let type = "image";
                        const response = await generatePresignedUrlForAccess({ name, type });

                        if (response?.success) {
                            return {
                                ...d,
                                thumbnailUrl: response.presignedUrl,
                            };
                        } else {
                            console.error('Error generating pre-signed URL for', d.thumbnailName);
                            return d;
                        }
                    }
                    return d;
                })
            );

            setAllCourses(updateData);
            setFilteredCourses(updateData);
        } catch (error) {
            console.error("Error updating thumbnails:", error);
            // Still set the courses even if thumbnail generation fails
            setAllCourses(data);
            setFilteredCourses(data);
        }
    }

    const handleDownloadCourseDetailsClick = async () => {
        try {
            setLoader(true);
            const authUser = localStorage.getItem('authUser');
            const organizationId = JSON.parse(authUser)?.organizationId;
            const response = await axios.get(DOWNLOAD_COURSE_DETAILS_FILE, {
                responseType: 'blob',
                headers: {
                    'X-Organization-ID': organizationId
                }
            });

            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'all_courses.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            toast.success("File downloaded successfully");
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || "Something went wrong while downloading");
        } finally {
            setLoader(false);
        }
    }

    const clearFilters = () => {
        setSearchTerm("");
        setSelectedCategory(null);
        setSelectedSubCategory(null);
        setSelectedLevel(null);
        setAllSubCategories([]);
        setFilteredSubCategories([]);
    }

    // Helper function to get category name from course
    const getCategoryName = (course) => {
        if (course?.categoryDto?.name) return course.categoryDto.name;
        if (course?.categoryName) return course.categoryName;
        if (course?.category?.name) return course.category.name;
        return 'N/A';
    }

    // Helper function to get subcategory name from course
    const getSubCategoryName = (course) => {
        if (course?.subCategoryDto?.name) return course.subCategoryDto.name;
        if (course?.subCategoryName) return course.subCategoryName;
        if (course?.subCategory?.name) return course.subCategory.name;
        return 'N/A';
    }

    // Helper function to get level name from course
    const getLevelName = (course) => {
        if (course?.levelDto?.name) return course.levelDto.name;
        if (course?.levelName) return course.levelName;
        if (course?.level?.name) return course.level.name;
        if (course?.levelDto?.level) return `Level ${course.levelDto.level}`;
        if (course?.level) return `Level ${course.level}`;
        return 'N/A';
    }

    // Helper function to get level number for sorting display
    const getLevelNumber = (course) => {
        if (course?.levelDto?.id) return parseInt(course.levelDto.id);
        if (course?.levelId) return parseInt(course.levelId);
        if (course?.levelDto?.level) return parseInt(course.levelDto.level);
        if (course?.level) return parseInt(course.level);
        return null;
    }

    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <div className="d-flex justify-content-between mb-3">
                                <CardTitle className="h4">All Courses </CardTitle>
                                <div className="">
                                    <button type="submit" className="btn btn-info w-md" onClick={handleDownloadCourseDetailsClick}>Download All Course File</button>
                                </div>
                            </div>

                            {/* Search and Filter Section */}
                            <div className="mb-4">
                                <Row>
                                    <Col md={3}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            label="Search courses"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <label className="form-label">Category</label>
                                        <Select
                                            value={selectedCategory}
                                            onChange={handleCategoryChange}
                                            options={allCategories}
                                            getOptionLabel={option => option?.name || ''}
                                            getOptionValue={option => option?.id?.toString() || ''}
                                            classNamePrefix="select2-selection"
                                            isClearable={true}
                                            placeholder="Select Category"
                                            styles={{
                                                menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999,
                                                }),
                                                control: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999,
                                                }),
                                            }}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <label className="form-label">Sub Category</label>
                                        <Select
                                            value={selectedSubCategory}
                                            onChange={handleSubCategoryChange}
                                            options={filteredSubCategories}
                                            getOptionLabel={option => option?.name || ''}
                                            getOptionValue={option => option?.id?.toString() || ''}
                                            classNamePrefix="select2-selection"
                                            isClearable={true}
                                            placeholder="Select Sub Category"
                                            isDisabled={!selectedCategory}
                                            styles={{
                                                menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999,
                                                }),
                                                control: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999,
                                                }),
                                            }}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <label className="form-label">Level</label>
                                        <Select
                                            value={selectedLevel}
                                            onChange={handleLevelChange}
                                            options={allLevels}
                                            getOptionLabel={option => option?.name || option?.level || `Level ${option?.id || ''}`}
                                            getOptionValue={option => option?.id?.toString() || ''}
                                            classNamePrefix="select2-selection"
                                            isClearable={true}
                                            placeholder="Select Level"
                                            styles={{
                                                menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999,
                                                }),
                                                control: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999,
                                                }),
                                            }}
                                        />
                                    </Col>
                                    <Col md={3} className="d-flex align-items-end">
                                        <Button 
                                            color="secondary" 
                                            onClick={clearFilters}
                                            className="w-100"
                                        >
                                            Clear Filters
                                        </Button>
                                    </Col>
                                </Row>
                            </div>

                            {/* Results Count and Level Filter Info */}
                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                <p className="text-muted mb-0">Showing {filteredCourses.length} courses</p>
                                {selectedLevel && (
                                    <span className="badge bg-info text-white p-2">
                                        Filtered by Level: {selectedLevel?.name || selectedLevel?.level || `Level ${selectedLevel?.id}`}
                                    </span>
                                )}
                            </div>

                            <div className="d-flex flex-row flex-wrap mt-3" style={{ minHeight: "60vh" }}>
                                {filteredCourses?.length > 0 ? (
                                    filteredCourses.map((d, i) => {
                                        const levelNumber = getLevelNumber(d);
                                        return (
                                            <div key={i} className="card me-5 mb-4" style={{ "width": "18rem", border: "4px solid gray", borderRadius: "10px", paddingTop: " " }} >
                                                <img className="card-img-top" src={d?.thumbnailUrl} alt="Card image cap" style={{ height: "40%" }} />
                                                <div className="card-body" >
                                                    <h5 className="card-title">{d?.title}</h5>
                                                    
                                                    {/* Category, Subcategory and Level Display */}
                                                    <div className="d-flex justify-content-between">
                                                        <h6>Category: </h6>
                                                        <p className="text-muted">{getCategoryName(d)}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <h6>Sub Category: </h6>
                                                        <p className="text-muted">{getSubCategoryName(d)}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <h6>Level: </h6>
                                                        <p className="text-muted">
                                                            <span className="badge" style={{
                                                                backgroundColor: levelNumber === 1 ? '#28a745' : 
                                                                              levelNumber === 2 ? '#ffc107' : 
                                                                              levelNumber === 3 ? '#fd7e14' : 
                                                                              levelNumber === 4 ? '#dc3545' : '#6c757d',
                                                                color: 'white'
                                                            }}>
                                                                {getLevelName(d)}
                                                            </span>
                                                        </p>
                                                    </div>

                                                    <div className="d-flex justify-content-between">
                                                        <h5>Duration: </h5>
                                                        <p>{d?.duration} Hours</p>
                                                    </div>

                                                    <div className="d-flex justify-content-between">
                                                        <h5>Language: </h5>
                                                        <p>{d?.language}</p>
                                                    </div>

                                                    <div className="d-flex justify-content-between">
                                                        <Button type="button" color="primary" onClick={() => handleEdit(d?.id)} className="waves-effect waves-light">Edit Course</Button>
                                                        <Button type="button" color="danger" onClick={() => handleDelete(d?.id)} className="waves-effect waves-light">Delete Course</Button>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="col-12 text-center py-5">
                                        <p className="h5">No courses found matching your filters.</p>
                                        <p className="text-muted">Try adjusting your search or filter criteria.</p>
                                        <Button color="primary" onClick={clearFilters} className="mt-3">
                                            Clear All Filters
                                        </Button>
                                    </div>
                                )}
                            </div>

                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(AllCourses);





// import React, { useEffect, useState } from "react"
// import { MDBDataTable } from "mdbreact"
// import { Row, Col, Card, CardBody, CardTitle, Button, FormGroup, Input } from "reactstrap"

// import { connect } from "react-redux";
// import Select from "react-select"

// //Import Action to copy breadcrumb items from local state to redux state
// import { setBreadcrumbItems } from "../../store/actions";

// import { useDispatch } from "react-redux";
// import Loader from "components/Loader/Loader";
// import { deleteCourse, fetchAllCourses } from "helpers/course_helper";
// import { toast } from "react-toastify";
// import { DOWNLOAD_COURSE_DETAILS_FILE, FETCH_IMAGE } from "helpers/url_helper";
// import { useNavigate } from "react-router-dom";
// import { generatePresignedUrlForAccess } from "helpers/Content_helper";
// import axios from "axios";
// import { TextField } from "@mui/material";
// import { fetchAllCategory } from "helpers/category_helper";
// import { fetchAllSubCategoryBasedOnCategory } from "helpers/subCategory_helper";

// const AllCourses = (props) => {
//     document.title = "Question Bank | All Courses";
//     const [modalShow, setModalShow] = useState(false);
//     const [courseName, setCourseName] = useState("");
//     const [courseDescription, setCourseDescription] = useState("");
//     const [courseCode, setCourseCode] = useState("");
//     const [spanDisplay, setSpanDisplay] = useState("none");
//     const [deleteModalShow, setDeleteModalShow] = useState(false);
//     const [id, setId] = useState({});
//     const [classs, setClasss] = useState(null);
//     const dispatch = useDispatch();
//     const [loader, setLoader] = useState(false);
//     const [allCourses, setAllCourses] = useState([]);
//     const [filteredCourses, setFilteredCourses] = useState([]);
//     const [searchTerm, setSearchTerm] = useState("");
//     const navigate = useNavigate();

//     // New state for filters
//     const [allCategories, setAllCategories] = useState([]);
//     const [allSubCategories, setAllSubCategories] = useState([]);
//     const [selectedCategory, setSelectedCategory] = useState(null);
//     const [selectedSubCategory, setSelectedSubCategory] = useState(null);
//     const [filteredSubCategories, setFilteredSubCategories] = useState([]);

//     const breadcrumbItems = [
//         { title: "Course", link: "#" },
//         { title: "All Courses", link: "#" },
//     ]

//     useEffect(() => {
//         props.setBreadcrumbItems('All Courses', breadcrumbItems)
//     }, [])

//     useEffect(() => {
//         const blurDiv = document.getElementById("blur");
//         var width = window.innerWidth;
//         if (width <= 994) {
//             blurDiv.click()
//         }
//     }, [])

//     useEffect(() => {
//         fetchCourses();
//         fetchCategories();
//     }, []);

//     useEffect(() => {
//         // Filter courses whenever searchTerm, selectedCategory, selectedSubCategory, or allCourses changes
//         let filtered = [...allCourses];

//         // Filter by search term (title)
//         if (searchTerm && searchTerm.trim() !== "") {
//             filtered = filtered.filter(course =>
//                 course?.title?.toLowerCase().includes(searchTerm.toLowerCase())
//             );
//         }

//         // Filter by category - using categoryDto.id or categoryId
//         if (selectedCategory) {
//             filtered = filtered.filter(course => {
//                 // Check if course has categoryDto with id matching selected category
//                 if (course?.categoryDto?.id) {
//                     return course.categoryDto.id === selectedCategory.id;
//                 }
//                 // Check if course has categoryId directly
//                 if (course?.categoryId) {
//                     return course.categoryId === selectedCategory.id;
//                 }
//                 return false;
//             });
//         }

//         // Filter by subcategory - using subCategoryDto.id or subCategoryId
//         if (selectedSubCategory) {
//             filtered = filtered.filter(course => {
//                 // Check if course has subCategoryDto with id matching selected subcategory
//                 if (course?.subCategoryDto?.id) {
//                     return course.subCategoryDto.id === selectedSubCategory.id;
//                 }
//                 // Check if course has subCategoryId directly
//                 if (course?.subCategoryId) {
//                     return course.subCategoryId === selectedSubCategory.id;
//                 }
//                 return false;
//             });
//         }

//         setFilteredCourses(filtered);
//     }, [searchTerm, selectedCategory, selectedSubCategory, allCourses]);

//     const fetchCourses = async () => {
//         try {
//             setLoader(true);
//             const data = await fetchAllCourses();
//             setLoader(false);
//             if (data?.success) {
//                 console.log("Course data:", data?.result);
//                 updateThubmnail(data?.result);
//             }
//             else {
//                 toast.error(data?.message || "Failed to fetch courses");
//             }
//         } catch (error) {
//             setLoader(false);
//             console.error("Error fetching courses:", error);
//             toast.error(error?.response?.data?.message || "Failed to fetch courses");
//         }
//     }

//     const fetchCategories = async () => {
//         try {
//             const data = await fetchAllCategory();
//             if (data?.success) {
//                 setAllCategories(data?.result || []);
//                 console.log("Categories:", data?.result);
//             }
//             else {
//                 console.error("Failed to fetch categories:", data?.message);
//             }
//         } catch (error) {
//             console.error("Error fetching categories:", error);
//         }
//     }

//     const fetchSubCategories = async (categoryId) => {
//         try {
//             setLoader(true);
//             // Try to fetch subcategories with proper headers
//             const authUser = localStorage.getItem('authUser');
//             const organizationId = authUser ? JSON.parse(authUser)?.organizationId : null;
            
//             // Make direct axios call with proper headers
//             const response = await axios.get(
//                 `https://backend.skillserve.in/getAllSubCategoryBasedOnCategory?categoryId=${categoryId}`,
//                 {
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Accept': 'application/json',
//                         ...(organizationId && { 'X-Organization-ID': organizationId })
//                     }
//                 }
//             );
            
//             setLoader(false);
            
//             if (response?.data?.success) {
//                 setAllSubCategories(response?.data?.result || []);
//                 setFilteredSubCategories(response?.data?.result || []);
//                 console.log("SubCategories for category:", response?.data?.result);
//             } else {
//                 setAllSubCategories([]);
//                 setFilteredSubCategories([]);
//                 if (response?.data?.message) {
//                     toast.warning(response.data.message);
//                 }
//             }
//         } catch (error) {
//             setLoader(false);
//             console.error("Error fetching subcategories:", error);
//             // Don't show error toast for subcategory fetch failure
//             setAllSubCategories([]);
//             setFilteredSubCategories([]);
//         }
//     }

//     const handleCategoryChange = (selectedValue) => {
//         setSelectedCategory(selectedValue);
//         setSelectedSubCategory(null); // Reset subcategory when category changes
//         if (selectedValue) {
//             fetchSubCategories(selectedValue.id);
//         } else {
//             setAllSubCategories([]);
//             setFilteredSubCategories([]);
//         }
//     }

//     const handleSubCategoryChange = (selectedValue) => {
//         setSelectedSubCategory(selectedValue);
//     }

//     const handleSearchChange = (e) => {
//         setSearchTerm(e.target.value);
//     };

//     const handleDelete = async (id) => {
//         console.log(id);
//         try {
//             setLoader(true);
//             const data = await deleteCourse(id);
//             setLoader(false);
//             if (data?.success) {
//                 toast.success(data?.message || "Course deleted successfully");
//                 fetchCourses();
//             }
//             else {
//                 toast.error(data?.message || "Failed to delete course");
//             }
//         } catch (error) {
//             setLoader(false);
//             console.error("Error deleting course:", error);
//             toast.error(error?.response?.data?.message || "Failed to delete course");
//         }
//     }

//     const handleEdit = async (id) => {
//         console.log(id);
//         navigate("/edit-course/" + id);
//     }

//     const updateThubmnail = async (data) => {
//         if (!data || data.length === 0) {
//             setAllCourses([]);
//             setFilteredCourses([]);
//             return;
//         }

//         try {
//             const updateData = await Promise.all(
//                 data.map(async (d) => {
//                     if (d?.thumbnailName) {
//                         let name = d.thumbnailName;
//                         let type = "image";
//                         const response = await generatePresignedUrlForAccess({ name, type });

//                         if (response?.success) {
//                             return {
//                                 ...d,
//                                 thumbnailUrl: response.presignedUrl,
//                             };
//                         } else {
//                             console.error('Error generating pre-signed URL for', d.thumbnailName);
//                             return d;
//                         }
//                     }
//                     return d;
//                 })
//             );

//             setAllCourses(updateData);
//             setFilteredCourses(updateData);
//         } catch (error) {
//             console.error("Error updating thumbnails:", error);
//             // Still set the courses even if thumbnail generation fails
//             setAllCourses(data);
//             setFilteredCourses(data);
//         }
//     }

//     const handleDownloadCourseDetailsClick = async () => {
//         try {
//             setLoader(true);
//             const authUser = localStorage.getItem('authUser');
//             const organizationId = JSON.parse(authUser)?.organizationId;
//             const response = await axios.get(DOWNLOAD_COURSE_DETAILS_FILE, {
//                 responseType: 'blob',
//                 headers: {
//                     'X-Organization-ID': organizationId
//                 }
//             });

//             const blob = new Blob([response.data], { type: response.headers['content-type'] });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'all_courses.xlsx');
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
//             toast.success("File downloaded successfully");
//         } catch (error) {
//             console.log(error);
//             toast.error(error?.response?.data?.message || "Something went wrong while downloading");
//         } finally {
//             setLoader(false);
//         }
//     }

//     const clearFilters = () => {
//         setSearchTerm("");
//         setSelectedCategory(null);
//         setSelectedSubCategory(null);
//         setAllSubCategories([]);
//         setFilteredSubCategories([]);
//     }

//     // Helper function to get category name from course
//     const getCategoryName = (course) => {
//         if (course?.categoryDto?.name) return course.categoryDto.name;
//         if (course?.categoryName) return course.categoryName;
//         if (course?.category?.name) return course.category.name;
//         return 'N/A';
//     }

//     // Helper function to get subcategory name from course
//     const getSubCategoryName = (course) => {
//         if (course?.subCategoryDto?.name) return course.subCategoryDto.name;
//         if (course?.subCategoryName) return course.subCategoryName;
//         if (course?.subCategory?.name) return course.subCategory.name;
//         return 'N/A';
//     }

//     return (
//         <React.Fragment>
//             {loader ? (
//                 <Loader />
//             ) : ("")}
//             <Row>
//                 <Col className="col-12">
//                     <Card>
//                         <CardBody>
//                             <div className="d-flex justify-content-between mb-3">
//                                 <CardTitle className="h4">All Courses </CardTitle>
//                                 <div className="">
//                                     <button type="submit" className="btn btn-info w-md" onClick={handleDownloadCourseDetailsClick}>Download All Course File</button>
//                                 </div>
//                             </div>

//                             {/* Search and Filter Section */}
//                             <div className="mb-4">
//                                 <Row>
//                                     <Col md={4}>
//                                         <TextField
//                                             fullWidth
//                                             variant="outlined"
//                                             label="Search courses"
//                                             value={searchTerm}
//                                             onChange={handleSearchChange}
//                                         />
//                                     </Col>
//                                     <Col md={3}>
//                                         <label className="form-label">Category</label>
//                                         <Select
//                                             value={selectedCategory}
//                                             onChange={handleCategoryChange}
//                                             options={allCategories}
//                                             getOptionLabel={option => option?.name || ''}
//                                             getOptionValue={option => option?.id?.toString() || ''}
//                                             classNamePrefix="select2-selection"
//                                             isClearable={true}
//                                             placeholder="Select Category"
//                                             styles={{
//                                                 menu: (provided) => ({
//                                                     ...provided,
//                                                     zIndex: 9999,
//                                                 }),
//                                                 control: (provided) => ({
//                                                     ...provided,
//                                                     zIndex: 9999,
//                                                 }),
//                                             }}
//                                         />
//                                     </Col>
//                                     <Col md={3}>
//                                         <label className="form-label">Sub Category</label>
//                                         <Select
//                                             value={selectedSubCategory}
//                                             onChange={handleSubCategoryChange}
//                                             options={filteredSubCategories}
//                                             getOptionLabel={option => option?.name || ''}
//                                             getOptionValue={option => option?.id?.toString() || ''}
//                                             classNamePrefix="select2-selection"
//                                             isClearable={true}
//                                             placeholder="Select Sub Category"
//                                             isDisabled={!selectedCategory}
//                                             styles={{
//                                                 menu: (provided) => ({
//                                                     ...provided,
//                                                     zIndex: 9999,
//                                                 }),
//                                                 control: (provided) => ({
//                                                     ...provided,
//                                                     zIndex: 9999,
//                                                 }),
//                                             }}
//                                         />
//                                     </Col>
//                                     <Col md={2} className="d-flex align-items-end">
//                                         <Button 
//                                             color="secondary" 
//                                             onClick={clearFilters}
//                                             className="w-100"
//                                         >
//                                             Clear Filters
//                                         </Button>
//                                     </Col>
//                                 </Row>
//                             </div>

//                             {/* Results Count */}
//                             <div className="mb-3">
//                                 <p className="text-muted">Showing {filteredCourses.length} courses</p>
//                             </div>

//                             <div className="d-flex flex-row flex-wrap mt-3" style={{ minHeight: "60vh" }}>
//                                 {filteredCourses?.length > 0 ? (
//                                     filteredCourses.map((d, i) => (
//                                         <div key={i} className="card me-5 mb-4" style={{ "width": "18rem", border: "4px solid gray", borderRadius: "10px", paddingTop: " " }} >
//                                             <img className="card-img-top" src={d?.thumbnailUrl} alt="Card image cap" style={{ height: "40%" }} />
//                                             <div className="card-body" >
//                                                 <h5 className="card-title">{d?.title}</h5>
                                                
//                                                 {/* Category and Subcategory Display */}
//                                                 <div className="d-flex justify-content-between">
//                                                     <h6>Category: </h6>
//                                                     <p className="text-muted">{getCategoryName(d)}</p>
//                                                 </div>
//                                                 <div className="d-flex justify-content-between">
//                                                     <h6>Sub Category: </h6>
//                                                     <p className="text-muted">{getSubCategoryName(d)}</p>
//                                                 </div>

//                                                 <div className="d-flex justify-content-between">
//                                                     <h5>Duration: </h5>
//                                                     <p>{d?.duration} Hours</p>
//                                                 </div>

//                                                 <div className="d-flex justify-content-between">
//                                                     <h5>Level: </h5>
//                                                     <p>{d?.levelDto?.name}</p>
//                                                 </div>
//                                                 <div className="d-flex justify-content-between">
//                                                     <h5>Language: </h5>
//                                                     <p>{d?.language}</p>
//                                                 </div>

//                                                 <div className="d-flex justify-content-between">
//                                                     <Button type="button" color="primary" onClick={() => handleEdit(d?.id)} className="waves-effect waves-light">Edit Course</Button>
//                                                     <Button type="button" color="danger" onClick={() => handleDelete(d?.id)} className="waves-effect waves-light">Delete Course</Button>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))
//                                 ) : (
//                                     <div className="col-12 text-center py-5">
//                                         <p className="h5">No courses found matching your filters.</p>
//                                         <p className="text-muted">Try adjusting your search or filter criteria.</p>
//                                         <Button color="primary" onClick={clearFilters} className="mt-3">
//                                             Clear All Filters
//                                         </Button>
//                                     </div>
//                                 )}
//                             </div>

//                         </CardBody>
//                     </Card>
//                 </Col>
//             </Row>
//         </React.Fragment>
//     )
// }

// export default connect(null, { setBreadcrumbItems })(AllCourses);